export default __webpack_public_path__ + "static/media/edu.290171e9.jpg";